import React, { useEffect, useRef, useState } from "react";
import HelpIconImage from "images/help-icon.svg";
import * as FP from "utils/fp-js";

const positions = {
  center: "center",
  right: "right",
  left: "left",
};

export const HelpIcon = ({ children }) => {
  const [isHelpVisible, setIsHelpVisible] = useState(false);
  const [position, setPosition] = useState(positions.left);
  const iconRef = useRef(null);

  const handlePosition = () => {
    if (iconRef.current) {
      const iconPosition = iconRef.current.getBoundingClientRect();
      const iconCenter = iconPosition.x + iconPosition.width / 2;
      const windowCenter = window.innerWidth / 2;
      if (windowCenter > 400) {
        setPosition(positions.left);
        return;
      };
      setPosition(iconCenter > windowCenter ? positions.right : positions.left);
    }
  };

  const handleIconClick = () => {
    handlePosition();
    setIsHelpVisible(!isHelpVisible);
  };

  useEffect(() => {
    window.addEventListener("resize", handlePosition);
    return () => window.removeEventListener("resize", handlePosition);
  }, []);

  if (!children) return null;

  return (
    <>
      <div className="relative overflow-visible">
        <img
          ref={iconRef}
          src={HelpIconImage}
          alt="Help Icon"
          onClick={handleIconClick}
          className="cursor-pointer hover:opacity-80"
        />
        {isHelpVisible &&
          FP.match(position)
            .on(
              positions.right,
              <>
                <div
                  className={`absolute top-8 -right-4 bg-white rounded-xl shadow-xl
                border border-gray-200
                z-40 p-6 w-52 sm:w-96 children-sm cursor-pointer`}
                  onClick={() => setIsHelpVisible(false)}
                >
                  {children}
                </div>
                <div
                  className={`absolute bg-white h-4 w-4 rotate-45 top-6 left-1 z-50
              border border-gray-200 border-b-0 border-r-0
              `}
                ></div>
              </>
            )
            .otherwise(
              <>
                <div
                  className={`absolute -left-4 top-8 bg-white rounded-xl shadow-xl
                border border-gray-200
                z-40 p-6 w-64 sm:w-96 children-sm cursor-pointer`}
                  onClick={() => setIsHelpVisible(false)}
                >
                  {children}
                </div>
                <div
                  className={`absolute bg-white h-4 w-4 rotate-45 top-6 left-1 z-50
              border border-gray-200 border-b-0 border-r-0
              `}
                ></div>
              </>
            )}
      </div>
      {isHelpVisible && (
        <div
          className="absolute top-0 right-0 bottom-0 left-0 z-49"
          onClick={() => setIsHelpVisible(false)}
        ></div>
      )}
    </>
  );
};
